// js/custom-element/custom-html-element.js
var CustomHTMLElement = class extends HTMLElement {
    constructor() {
        super();
        this._hasSectionReloaded = false;
        if (Shopify.designMode) {
            this.rootDelegate.on("shopify:section:select", (event) => {
                const parentSection = this.closest(".shopify-section");
                if (event.target === parentSection && event.detail.load) {
                    this._hasSectionReloaded = true;
                }
            });
        }

        const navButtons = this.querySelectorAll('.gallery-accordion__nav div');

        if (window.innerWidth < 769) {
            navButtons.forEach(button => {
                button.addEventListener("click", (event) => this.navigateScroll(event));
            });
        }

    }
    navigateScroll(e) {
        e.preventDefault?.();

        const target = e.currentTarget;
        const container = this.querySelector('.gallery-accordion');
        const currentScroll = this.getAttribute("data-current-scroll") || 0;
        if (!container) return;

        const item = this.querySelector('.shop-the-look__item');
        const items = this.querySelectorAll('.shop-the-look__item');
        const count = items.length || 1;

        // ✅ classList.contains takes the class name (no dot)
        const isNext = target.classList.contains('gallery-accordion__next');
        const dir = isNext ? 1 : -1;

        // Total horizontal range you can actually scroll
        const maxScroll = dir * (container.scrollWidth / count);
        if (maxScroll === 0) return;
        const scrollAmount = Number(currentScroll) + Number(maxScroll);
        if (scrollAmount == container.scrollWidth || scrollAmount < 0) {
            return
        }

        // Step = 1/(#items) of full scroll range.
        // If you prefer to land exactly at the end after (count-1) taps, change `count` to `count - 1` (min 1)
        container.scrollTo({ left: scrollAmount, behavior: 'smooth' });
        this.setAttribute("data-current-scroll", Number(currentScroll) + Number(maxScroll));
    }


    get rootDelegate() {
        return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
    }
    get delegate() {
        return this._delegate = this._delegate || new main_default(this);
    }
    showLoadingBar() {
        triggerEvent(document.documentElement, "theme:loading:start");
    }
    hideLoadingBar() {
        triggerEvent(document.documentElement, "theme:loading:end");
    }
    untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
        const onBecameVisible = () => {
            this.classList.add("became-visible");
            this.style.opacity = "1";
        };
        return new Promise((resolve) => {
            if (window.IntersectionObserver) {
                this.intersectionObserver = new IntersectionObserver((event) => {
                    if (event[0].isIntersecting) {
                        this.intersectionObserver.disconnect();
                        requestAnimationFrame(() => {
                            resolve();
                            onBecameVisible();
                        });
                    }
                }, intersectionObserverOptions);
                this.intersectionObserver.observe(this);
            } else {
                resolve();
                onBecameVisible();
            }
        });
    }
    disconnectedCallback() {
        var _a;
        this.delegate.destroy();
        this.rootDelegate.destroy();
        (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
        delete this._delegate;
        delete this._rootDelegate;
    }
};

// js/custom-element/section/shop-the-look/shop-the-look.js
var ShopTheLook = class extends CustomHTMLElement {
    connectedCallback() {
        this.lookItems = Array.from(this.querySelectorAll("shop-the-look-item"));
        this.nav = this.querySelector("shop-the-look-nav");
        this.hasPendingTransition = false;
        if (this.hasAttribute("reveal-on-scroll")) {
            this._setupVisibility();
        }
        if (this.lookItems.length > 1 && Shopify.designMode) {
            this.addEventListener("shopify:block:select", async (event) => {
                this.intersectionObserver.disconnect();
                await this.select(event.target.index, !event.detail.load);
                this.nav.animate({ opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0, fill: "forwards", easing: "ease-in-out" });
            });
        }
    }
    get selectedIndex() {
        return this.lookItems.findIndex((item) => item.selected);
    }
    async _setupVisibility() {
        await this.untilVisible();
        const images = Array.from(this.lookItems[this.selectedIndex].querySelectorAll(".shop-the-look__image"));
        for (let image of images) {
            if (image.offsetParent !== null) {
                await imageLoaded(image);
            }
        }
        await this.lookItems[this.selectedIndex].transitionToEnter();
        if (this.nav) {
            this.nav.animate({ opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 150, fill: "forwards", easing: "ease-in-out" });
        }
    }
    previous() {
        this.select((this.selectedIndex - 1 + this.lookItems.length) % this.lookItems.length);
    }
    next() {
        this.select((this.selectedIndex + 1 + this.lookItems.length) % this.lookItems.length);
    }
    async select(index, animate = true) {
        const currentLook = this.lookItems[this.selectedIndex], nextLook = this.lookItems[index];
        if (this.hasPendingTransition) {
            return;
        }
        this.hasPendingTransition = true;
        if (currentLook !== nextLook) {
            this.nav.transitionToIndex(this.selectedIndex, index, animate);
            currentLook.transitionToLeave();
        }
        nextLook.transitionToEnter(animate);
        this.hasPendingTransition = false;
    }
};
window.customElements.define("shop-the-look", ShopTheLook);